import { createAPIProxy } from './utils/api';
import { API as CorpAPI } from '@libs/shared';

const API = {
    ...CorpAPI,
    /**
     * 开放平台设计与 jdy 存在一定耦合还未拆开，当 jdy_router_switch = false 时，需要调用该接口获取 jdy 权限 & vip
     * @deprecated
     */
    get_login_user: '/corp/v2/login_user_info',
    app: {
        apps: '/profile/get_app_list',
        install: '/dashboard/template/install',
        get_install_plugin: '/dashboard/template/list_plugin',
        /** 应用搭建侧 - 数据源相关 */
        data_source: {
            ref_brief: '/_/data_process/admin/app/data_source_table/reference/query_brief',
            ref_detail: '/_/data_process/admin/app/data_source_table/reference/query_detail'
        }
    },
    help: {
        find_solution: '/tpl/solution_template/find',
        hot_search: '/tpl/op_config/hot_search',
        solution_list: '/tpl/solution_template/list',
        solution_view: '/tpl/solution_template/view',
        tag_list: '/tpl/tag/list',
        solution_recommend: '/tpl/solution_template/recommend'
    },
    // 开放平台
    open: {
        ...CorpAPI.open,
        store: CorpAPI.open.store,
        get_permission: '/open/get_permission',
        app_list: '/open/app_builder/app/list',
        /** api调试台 */
        api: {
            list: '/open/api/list',
            get: '/open/api/get',
            debug: '/open/api/debug',
            demo: '/open/api/demo'
        },
        /** 第三方授权管理 */
        user_oauth: {
            login: '/open/user/oauth/login',
            device: '/open/user/oauth/device'
        },
        // 秘钥管理
        key_list: '/open/open_api_key/list',
        key_create: '/open/open_api_key/create',
        key_update: '/open/open_api_key/update',
        key_delete: '/open/open_api_key/delete',
        key_log_list: '/open/open_api_log/list',
        api_list: '/open/api/list',
        api_log_export: '/open/open_api_log/export',
        key_duplicate: '/open/open_api_key/duplicate',
        // 第三方平台授权管理
        oauth_status_update: '/open/user/oauth/status',
        oauth_login: '/open/user/oauth/login',
        oauth_list: '/open/user/oauth/suites',
        oauth_revoke: '/open/owner/agent/revoke_oauth',
        // 数据源
        data_source: {
            detail: '/open/owner/data_source/detail',
            table_fields: '/open/owner/data_source/get_table_fields',
            create_pipeline: '/open/owner/data_source/pipeline/create',
            /** 市场 */
            store: {
                list: '/open/store/data_source/list',
                trial: '/open/store/data_source/trial'
            },
            /** 授权管理 */
            credentials: {
                create: '/open/owner/data_source/credentials/create',
                list: '/open/owner/data_source/credentials/list',
                generate_url: '/open/owner/data_source/credentials/generate_url',
                update: '/open/owner/data_source/credentials/update',
                delete: '/open/owner/data_source/credentials/delete',
                usage: '/open/owner/data_source/credentials/usage'
            },
            /** 数据连接 */
            connection: {
                connection_create: '/open/owner/data_source/connection/create'
            },
            /** 同步表 */
            table: {
                list: '/open/owner/data_source/table/list',
                list_latest_logs: '/open/owner/data_source/table/list_latest_logs',
                update: '/open/owner/data_source/table/update',
                delete: '/open/owner/data_source/table/delete',
                delete_sub_table: '/open/owner/data_source/table/delete_sub_table',
                trigger_sync: '/open/owner/data_source/table/trigger_sync',
                stop_sync: '/open/owner/data_source/table/stop_sync',
                list_sync_logs: '/open/owner/data_source/table/list_sync_logs'
            }
        },
        // 插件管理
        store_plugin_list: '/open/store/plugin/list',
        store_recommended_plugin_list: '/open/store/plugin/recommended',
        plugin_tag_list: '/open/store/tag/list',
        plugin_update: '/open/owner/agent/update',
        plugin_uninstall: '/open/owner/agent/uninstall',
        plugin_install: '/open/store/plugin/install',
        plugin_sort: '/open/owner/agent/sort',
        plugin_trial: '/open/store/plugin/trial',
        // 创建插件发布请求pr
        plugin_pull_request_create: '/open/isv/pull_request/create',
        /** 同意协议 */
        agreement_approve: '/open/owner/plugin/license/approve',
        get_field_meta: '/open/field/metadata',
        private_plugin: {
            // 创建自建插件
            create: '/open/owner/plugin/create',
            // 删除自建插件
            delete: '/open/owner/plugin/delete',
            export: '/open/owner/plugin/export',
            get_import_token: '/upload/get_plugin_import_token',
            import_parse: '/_/open_process/owner/plugin/import/parse',
            import: '/open/owner/plugin/import',
            import_overwrite: '/_/open_process/owner/plugin/import/overwrite',
            // 编辑插件
            get: '/open/owner/plugin/get',
            // copy自建插件
            duplicate: '/open/owner/plugin/duplicate',
            // 保存插件属性
            update_attr: '/open/owner/plugin/update',
            // 获取自建插件触发动作的调试信息
            get_debug_info: '/open/owner/plugin/trigger/debug/get',
            // 进行自建插件调试
            debug: '/open/owner/plugin/trigger/debug/invoke',
            // 支持的auth类型
            auth_template: '/open/auth_template/list',
            // 前端函数
            fronted: {
                function_list: '/open/owner/plugin/applet/list',
                get: '/open/owner/plugin/applet/get',
                delete: '/open/owner/plugin/applet/delete',
                create: '/open/owner/plugin/applet/create',
                update: '/open/owner/plugin/applet/update',
                sort: '/open/owner/plugin/applet/sort'
            },
            // 后端函数
            backend: {
                function_list: '/open/owner/plugin/trigger/list',
                get: '/open/owner/plugin/trigger/get',
                delete: '/open/owner/plugin/trigger/delete',
                create: '/open/owner/plugin/trigger/create',
                update: '/open/owner/plugin/trigger/update',
                sort: '/open/owner/plugin/trigger/sort'
            },
            chat: {
                create: '/open/owner/plugin/chat/create',
                get: '/open/owner/plugin/chat/get',
                completion: '/open/owner/plugin/chat/completions'
            }
        },
        // 创建插件更新请求pr
        plugin_pull_request_update: '/open/isv/pull_request/update',
        // 申请上架
        plugin_pull_request_release: '/open/isv/plugin/update',
        plugin_pull_request_delete: '/open/isv/pull_request/delete',
        plugin_pull_request_get: '/open/isv/pull_request/get',
        // 插件pr记录
        plugin_pull_request_list: '/open/isv/pull_request/list',
        installed_list: '/open/owner/agent/list',
        get_plugin_detail: '/open/owner/agent/get',
        // 获取已安装的前端插件列表
        manage_agent_list: '/open/manage/agent/list',
        // 获取某个前端插件的详情
        manage_agent_get: '/open/manage/agent/get',
        // 获取已装插件包含的函数列表
        installed_plugin_function_list: '/open/manage/agent/list_trigger',
        // 加载后端函数插件模板
        get_trigger_template: '/open/manage/agent/get_trigger',
        /** 获取插件runtime配置 */
        runtime_list: '/open/trigger_runtime/list',
        /** 自定义 Runtime（依赖环境） */
        runtime: {
            create: '/open/custom_runtime/create',
            get: '/open/custom_runtime/get',
            list: '/open/custom_runtime/list',
            update: '/open/custom_runtime/update',
            delete: '/open/custom_runtime/delete',
            deploy: '/open/custom_runtime/deploy',
            log_list: '/open/custom_runtime/log/list',
            plugin_list: '/open/trigger_runtime/plugin/list'
        },
        // 获取同步ip
        get_proxy_ip: '/open/data_sync/proxy/list',
        // 获取插件版本特性
        get_plugin_changelog: '/open/store/plugin/changelog',
        // ISV服务商信息
        get_isv_info: '/open/isv',
        // 自建插件使用情况统计
        get_plugin_usage_stat: '/open/isv/plugin/stats',
        // ISV服务商收益信息
        get_isv_income: '/open/isv/asset',
        // ISV服务商指定插件信息
        get_isv_plugin: '/open/isv/plugin/get',
        get_open_api_info: '/open/open_api/get_info',
        mcp: {
            create: '/open/member_mcp/create',
            list: '/open/member_mcp/list',
            renew: '/open/member_mcp/renew',
            update: '/open/member_mcp/update',
            delete: '/open/member_mcp/delete',
            refresh: '/open/member_mcp/refresh',
            api_list: '/open/member/api/list',
            api_log_list: '/open/member_api_log/list',
            log_export: '/open/member_api_log/export',
            oauth_authorize: '/oauth/mcp/authorize/confirm',
            permission_apply: {
                create: '/open/api_key_permission_apply/create',
                list: '/open/api_key_permission_apply/list',
                cancel: '/open/api_key_permission_apply/cancel',
                admin_list: '/open/api_key_permission_apply/admin_list',
                approve: '/open/api_key_permission_apply/approve',
                reject: '/open/api_key_permission_apply/reject',
                batch_approve: '/open/api_key_permission_apply/batch_approve',
                batch_reject: '/open/api_key_permission_apply/batch_reject'
            }
        }
    },
    form_auto_fill: {
        list: '/_/app/entry/form_auto_fill/list'
    },
    ai_assistant: {
        admin_get_config: '/_/admin/ai/assistant/skills/get_config',
        admin_set_config: '/_/admin/ai/assistant/skills/set_config',
        get_skill_list: '/_/admin/ai/assistant/kms/agent/skill/config/list',
        search_entry_status: '/_/admin/ai/search_entry/status'
    },
    profile: {
        get_coin_conf: '/profile/get_coin_conf',
        set_coin_conf: '/profile/set_coin_conf'
    }
};

export default createAPIProxy(API);
